/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

const brandColors = {
    '1800flowers': {
        primary: '#201648',
        chipBackground: '#F0ECF7',
        subTitle: '#7E3799',
    },
};

export default brandColors;
